/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import _forEach from 'lodash/forEach';
import utilityService from './utility.service';
import { setAirportSearchHistory } from './aws/user/setAttributes/setAirportSearchHistory';
import { getUserDetails } from './user/getUserDetails';
import { setUserAttributeInStore } from './user/setUserAttributeInStore';

const searchHistoryService = () => {
  const content = {};
  content.airportHistorySearches = [];
  content.getAirportHistory = () => {
    const user = getUserDetails();
    let historyData = utilityService.clone(user.airport_search_history) || [];
    // Remove duplicate entries
    historyData = utilityService.removeDuplicatesByKeyFromObjectInterface(historyData, 'value');
    _forEach(historyData, (value) => {
      value.logDate = new Date(value.logDate);
    });
    // Sort history data so that we show latest airport first
    return historyData ? historyData.sort(utilityService.sortByDate) : [];
  };
  content.setAirportHistory = function (airport) {
    if (airport) {
      const historyList = content.getAirportHistory() || [];
      const historyItem = {
        logDate: new Date(),
        value: airport.toUpperCase(),
      };
      let alreadyExistIndex = -1;
      _forEach(historyList, (item, key) => {
        if (item.value.toUpperCase() === airport.toUpperCase()) {
          alreadyExistIndex = key;
        }
      });
      if (alreadyExistIndex > -1) {
        historyList.splice(alreadyExistIndex, 1);
      }
      historyList.push(historyItem);
      setAirportSearchHistory(historyList);
      setUserAttributeInStore({key:"airport_search_history", value:historyList});
    }
  };
  content.loadAirportHistorySearch = () => {
    content.airportHistorySearches = content.getAirportHistory();
    let i = 0;
    let matchFound;
    while (i < content.airportHistorySearches.length) {
      matchFound = utilityService.getMatchedAirportObject(content.airportHistorySearches[i].value);
      if (matchFound) {
        content.airportHistorySearches[i].lat = matchFound.lat;
        content.airportHistorySearches[i].lng = matchFound.lng;
        content.airportHistorySearches[i].icao_id = matchFound.icao_id;
        content.airportHistorySearches[i].faa_facility_name = matchFound.faa_facility_name;
        content.airportHistorySearches[i].value = matchFound.icao_id;
      }
      i += 1;
    }
    return content.airportHistorySearches;
  };
  return content;
};
export default searchHistoryService();
